import {ReactElement, ReactNode} from "react";
import {Button} from "@zendeskgarden/react-buttons";
import {DragOverlay} from "@dnd-kit/core";
import * as css from "./styles/DnDKitDraggable.module.scss";
import {ReactComponent as Grip} from "@zendeskgarden/svg-icons/src/16/grip.svg";

export interface DnDKitDragOverlayProps {
    children?: ReactNode | ReactNode[];
}

export function DnDKitDragOverlay(props: DnDKitDragOverlayProps): ReactElement {
    let child: ReactNode | null = null;
    if(props.children || (Array.isArray(props.children) && props.children.length > 0)) {
        child = <div className={css.dndkitDraggable}>
            <div>
                <Button isBasic aria-label="Grip here to drag."><Grip /></Button>
            </div>
            <div>
                {props.children}
            </div>
        </div>;
    }

    return <DragOverlay>
        {child}
    </DragOverlay>;
}